import React, { useState } from 'react';
import moment from 'moment-timezone';
import { Field, reduxForm } from 'redux-form';

import { SelectInput } from '../SelectInput';
import { DatePickerInput } from '../DatePickerInput';
import i18next from "i18next";

import config from "config";

const EventNotesReportForm = ({ groupingValues, disabled, fromPrint, handleSubmit, groupingSelected, showPrintButton, printClicked }) => {
  const [acceptedTimeframe, setAcceptedTimeframe] = useState(false);
  const [beforeStart, setBeforeStart] = useState(false);
  const [endAtDate, setEndAtDate] = useState(null);
  const [startAtDate, setStartAtDate] = useState(null);
  const [startAtValue, setStartAtValue] = useState(null);
  const [endAtValue, setEndAtValue] = useState(null);
  const [clear, setClear] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [grouping, setGrouping] = useState(null);

  const localGroupingSelected = (updatedGrouping) => {
    if (grouping && updatedGrouping.value === grouping.value) {
      // if choosing current grouping do nothing
      return;
    }
    
    groupingSelected();

    setGrouping(updatedGrouping);
    setAcceptedTimeframe(false);
    setClear(true);

    startAtSelected(startAtValue);
  }

  const startAtSelected = (date) => {
    if (date == null) {
      setEndAtDate(null);
      setStartAtDate(null);
      setAcceptedTimeframe(false);
      return
    }

    const startAt = date;
    const endDate = moment(startAt).add(3, 'month').toDate();

    setClear(false);
    setEndAtDate(endDate);
    setStartDate(startAt);
    setStartAtValue(date);

    endAtSelected(endDate);
  }

  const endAtSelected = (date) => {
    if (date == null) {
      setAcceptedTimeframe(false);
      setEndAtValue(null);
      setBeforeStart(false);
    } else {
      const endDate = moment(date);
      if (endDate.isSameOrBefore(endAtDate) && endDate.isSameOrAfter(startDate)) {
        setAcceptedTimeframe(true);
        setEndAtValue(date);
      } else {
        setAcceptedTimeframe(false);
        setEndAtValue(date);
        setBeforeStart(endDate.isBefore(startDate));
      }
    }
  }

  const hintText = beforeStart && !acceptedTimeframe ? i18next.t('messages.date-out-of-range') : i18next.t('messages.date-range-instructions', {timeframe: 90});
  return (
    <div className="op-content-box filter-box" style={{marginBottom: 20}}>
      <form onSubmit={handleSubmit}>
        <ul className="list-inline clearfix">
          <li className="pull-left box-label"><h4 className="remove-margin-bottom">{ i18next.t('filters') }</h4></li>
        </ul>

        <div className = "row">
          <div className="col-sm-3">
            <label>{ i18next.t('form-labels.location') }</label>
            <Field
                name={`location`}
                options={groupingValues}
                clearable={false}
                searchable={true}
                component={SelectInput}
                onChange={(value) => localGroupingSelected(value)}
                props={{isDisabled: disabled}}
                placeholder={ i18next.t('form-labels.select-location') }
            />
          </div>

          {
            (grouping || fromPrint) &&
            <div>
              <div className="align-date-picker pull-left">
                <label>{ i18next.t('form-labels.date-range') }</label>
                  <Field
                      name={`startAtDate`}
                      component={DatePickerInput}
                      onDayChange={(value) => startAtSelected(value)}
                      isDisabled = {disabled}
                  />
              </div>
              <div className="dash pull-left">-</div>
              <div className="align-date-picker pull-left">
                <label className="date-end" style={{visibility: 'hidden'}}>{ i18next.t('form-labels.range-end') }</label>
                  <Field
                      name={`endAtDate`}
                      component={DatePickerInput}
                      onDayChange = {(value) => endAtSelected(value)}
                      dayPickerProps = {{
                        month: startDate,
                        fromMonth: startDate,
                        disabledDays: { before: startDate }
                      }}
                      isDisabled = {disabled}
                  />
              </div>
            </div>
          }

          {
            acceptedTimeframe && showPrintButton &&
            <div className="pull-right print-image tooltip">
              <a>
                <img src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/print_icon.svg`}
                      className="print-icon"
                      onClick={printClicked}
                      alt={i18next.t('pages.event-notes-report.print-report')} />
              </a>
              <span className="tooltiptext print-image">{ i18next.t('print') }</span>
            </div>
          }

          {
            acceptedTimeframe &&
            <div className="pull-left">
                <label style={{visibility: 'hidden'}}>{ i18next.t('form-labels.run-report') }</label>
                <ul className="list-inline clearfix">
                  <li className="pull-left" style={{marginLeft: '15px'}}><button type="submit" className="btn btn-sm btn-default pull-right" >{ i18next.t('form-labels.run-report') }</button></li>
                </ul>
            </div>
          }
        </div>

        {
          endAtDate && !acceptedTimeframe && endAtValue && !clear &&
          <div className = "hint">
            <p> {hintText} </p>
          </div>
        }
      </form>
    </div>
  );
}

export default reduxForm({ form: 'EventNotesReportForm' })(EventNotesReportForm);
